<template>
  <svg
    v-if="type === 'spinner'"
    class="animate-spin"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      class="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      :stroke-width="strokeWidth"
    />

    <path
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      fill="currentColor"
      :stroke-width="strokeWidth"
    />
  </svg>
  <div
    v-else-if="type === 'dots'"
    class="dot-loader"
  >
    <div
      v-for="n in 3"
      :key="n"
      :style="{
        backgroundColor: 'currentColor',
        animationDelay: `${250 * n}ms`
      }"
    />
  </div>
</template>

<script>
export default {
  props: {
    strokeWidth: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: 'spinner',
      validator: value => ['spinner', 'dots'].includes(value)
    }
  }
};
</script>
<style lang="scss" scoped>
.dot-loader {
  @apply flex gap-2;

  div {
    @apply block w-2 h-2 rounded-full flex-none opacity-25;
    animation: fade 0.6s infinite alternate;
  }
}

@keyframes fade {
  0%{opacity: 0.25}
  5%{opacity: 0.25}
  95%{opacity: 1}
  100%{opacity: 1}
}
</style>
